import './../MemberStat.css';
import React, {Component} from 'react';
import axios from 'axios';
import config from '../../config.json';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';  
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);




class MemberClassementChart extends Component{
    constructor() {
        super();
        this.state = { data: null};
        this.options = {
            scales: {
                y: {
                    ticks: {
                        
                    }
                },
                x: {
                    ticks: {

                    }
                }
            },
            plugins: {
                legend: {
                    display:false
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
    
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                let millierMulti = Math.floor(context.parsed.y/1000)
                                if(context.parsed.y > 1000) {
                                    label += context.parsed.y - (1000 * millierMulti);
                                } else {
                                    label += context.parsed.y
                                }
                            }
                            return label;
                        }
                    }
                },
                datalabels: {
                    align : 'top',
                    display: function(context) {
                        return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                    },
                    formatter: function(value, context) {
                        //return context.dataIndex + '%';
                        let millierMulti = Math.floor(context.dataset.data[context.dataIndex]/1000)
                        if(context.dataset.data[context.dataIndex] > 1000) {
                            return context.dataset.data[context.dataIndex] - (1000 * millierMulti);
                        } else {
                            return context.dataset.data[context.dataIndex];
                        }
                        
                      }
                },
            }  
        }
    }
    
    componentDidMount() {
        axios.get(`${config.base_url}/api/snapshot/${this.props.puuid}`)
          .then(res => {
            const data = res.data;
            let yAxis = data.map((elem) => elem.tier+ ' '+elem.rank);
            //let xAxis = data.map((elem) => elem.league_points);
            let dateHeure = data.map((elem) => elem.created_at);
            let tabThreshold = [];
            data.forEach(function(elem) {
                let currentData = elem.tier+ ' ' + elem.rank;
                if(!tabThreshold.includes(currentData)){
                    tabThreshold.push(elem.tier+ ' ' + elem.rank);
                }
            })   
            //this.options.scales.y.ticks.
            this.options.scales.y.ticks = {
                min: 0,
                max: tabThreshold.length*1000,
                stepSize: 1000,
                suggestedMin: 1000,
                beginAtZero: false,
                //suggestedMax: 5.5,
                callback : function(value, index, ticks) {
                    let millierMulti = Math.floor(value/1000)
                    if(value > 1000) {
                        return tabThreshold[millierMulti-1]
                    } else {
                        return tabThreshold[0]
                    }
                }
            }
            this.options.scales.x.ticks = {
                callback : function(value, index, ticks) {
                    let dataHeure = dateHeure[index].split("T")[1].split(":")
                    return dataHeure[0]+":"+dataHeure[1];
                }
            }
            this.options.plugins = {
                legend: {
                    display:false
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
    
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                let millierMulti = Math.floor(context.parsed.y/1000)
                                if(tabThreshold.length === 1) {
                                    label += context.parsed.y
                                } else {
                                    if(context.parsed.y > 1000) {
                                        label += context.parsed.y - (1000 * millierMulti);
                                    } else {
                                        label += context.parsed.y
                                    }
                                }
                                
                            }
                            return label;
                        }
                    }
                },
                datalabels: {
                    align : 'top',
                    display: function(context) {
                        return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                    },
                    formatter: function(value, context) {
                        //return context.dataIndex + '%';
                        let millierMulti = Math.floor(context.dataset.data[context.dataIndex]/1000)
                        if(tabThreshold.length === 1) {
                            return context.dataset.data[context.dataIndex];
                        } else {
                            if(context.dataset.data[context.dataIndex] > 1000) {
                                return context.dataset.data[context.dataIndex] - (1000 * millierMulti);
                            } else {
                                return context.dataset.data[context.dataIndex];
                            }
                        }
                        
                        
                      }
                },
            } 

            data.forEach(function(elem,index) {
                let currentData = elem.tier+ ' ' + elem.rank;

                let thresholdIndex = tabThreshold.findIndex((elem) => elem === currentData);
                if(tabThreshold.length === 1) {

                } else {
                    data[index].league_points = elem.league_points + (1000 * (thresholdIndex+1));
                }
                
            })

            const labels = yAxis;
            const ChartData = {
                labels,
                datasets: [
                {
                    type: 'line',
                    label: 'LP',
                    data: data.map((elem) => elem.league_points),
                    //backgroundColor: 'rgba(228, 184, 73, 0.4)',
                    borderColor: 'rgba(228, 184, 73, 1)',
                    //borderColor: 'rgb(255, 99, 132)',
                    //backgroundColor: 'rgba(255, 99, 132, 0.5)',
                }
                ],
            };
  
            this.setState({ data: ChartData})
          })
    }

    
    render() {
        if(this.state.data != null){
            return(
                <Line data={this.state.data} options={this.options} />
            )
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
        
    }
}
export default MemberClassementChart